import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFirestore, collection, query, where, getDocs, doc } from 'firebase/firestore';
import LeftBar from '../Components/LeftBar'
import LeftbarUser from '../Components/LeftbarUser.js';
import BottomNavUser from '../Components/BottomNavUser.js';
import Topbar from '../Components/Topbar'
import profDefault from '../Images/def.png'
import { Link } from 'react-router-dom'
import defaultCover from '../Images/coverbg.jpg'
import Button from "react-bootstrap/Button";
import { app } from "../firebase.js"
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import BottomNav from '../Components/BottomNav'

import { Card, Row, Col, ListGroup, Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faClock, faEye, faFaceSmile, faUser, faWallet } from '@fortawesome/free-solid-svg-icons'

import { getDatabase, ref as dbRef, get, set, runTransaction } from "firebase/database";
import Chart from "react-apexcharts";

import icInstagram from '../Images/instagram2.png'
import icYoutube from '../Images/youtube.png'
import icTiktok from '../Images/tiktok.png'
import icLinkedin from '../Images/Linkedin.svg'
import icTwitter from '../Images/Twitter.svg'
import subsImg from '../Images/p_img3.svg'

import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';

function ViewUser() {
    const { username } = useParams();
    const db = getFirestore(app);

    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);

    const cleanUsername = username.replace('@', '').toLowerCase();

    const [activeTab, setActiveTab] = useState('socials');
    const navigate = useNavigate();
    const [Username, setUsername] = useState("")
    const [UserEmail, setUserEmail] = useState("")

    const [userId, setUserId] = useState()

    const [dateJoined, setDateJoined] = useState("");
    const [profileViews, setProfileViews] = useState(0);
    const [isVerified, setIsVerified] = useState(false)
    const [acceptingAds, setacceptingAds] = useState(false);
    const [subscriptionExpiry, setSubscriptionExpiry] = useState(null)
    const [isSubscriptionActive, setIsSubscriptionActive] = useState(false)
    const [acceptingSubs, setacceptingSubs] = useState(false);


    const rdb = getDatabase(app);
    const [profileData, setProfileData] = useState({
        userName: "",
        theUsername: "",
        email: "",
        phoneNumber: "",
        mpesaNumber: "",
        profileImage: profDefault,
        coverImage: defaultCover,
        adsNotAccepted: {},
        socials: {},
        socialUrls: {}
    });

    const [selectedPlatforms, setSelectedPlatforms] = useState({
        instagram: false,
        tiktok: false,
        youtube: false,
        twitter: false
    });

    const [socialStats, setSocialStats] = useState({
        instagram: {},
        tiktok: {},
        youtube: {},
        twitter: {}
    });

    const [servicePricing, setServicePricing] = useState({});
    const [profileLink, setProfileLink] = useState("");



    useEffect(() => {
        const fetchUser = async () => {
            try {
                const q = query(
                    collection(db, "users"),
                    where("theUsername", "==", cleanUsername)
                );
                const querySnap = await getDocs(q);

                if (querySnap.empty) {
                    setLoading(false);
                    setUserData(null);
                    return;
                }

                // Assuming usernames are unique, get first match
                const docSnap = querySnap.docs[0];
                const data = docSnap.data();
                const uid = docSnap.id; // <-- This is the actual userId from Firestore

                setUserId(uid);
                setUserData(data);
                setIsVerified(data.accountIsVerified || false);
                setacceptingAds(data.acceptingAds || false);
                setacceptingSubs(data.acceptingSubs || false);

                const expiry = data.subscriptionExpiry
                    ? data.subscriptionExpiry.toDate()
                    : null

                setSubscriptionExpiry(expiry)
                setIsSubscriptionActive(expiry && expiry > new Date())

                // Selected platforms
                setSelectedPlatforms({
                    instagram: data.socials?.instagram === "selected" || data.socials?.instagram === true,
                    tiktok: data.socials?.tiktok === "selected" || data.socials?.tiktok === true,
                    youtube: data.socials?.youtube === "selected" || data.socials?.youtube === true,
                    twitter: data.socials?.twitter === "selected" || data.socials?.twitter === true
                });

                // Social stats
                setSocialStats({
                    instagram: data.socialStats?.instagram || {},
                    tiktok: data.socialStats?.tiktok || {},
                    youtube: data.socialStats?.youtube || {},
                    twitter: data.socialStats?.twitter || {}
                });

                // Service pricing
                if (data.servicePricing) setServicePricing(data.servicePricing);

                // Profile data
                const fresh = {
                    userName: data.userName || "",
                    theUsername: data.theUsername || "",
                    email: data.email || "",
                    phoneNumber: data.phoneNumber || "",
                    mpesaNumber: data.mpesaNumber || "",
                    profileImage: data.profileImage || profDefault,
                    coverImage: data.coverImage || defaultCover,
                    adsNotAccepted: data.adsNotAccepted || {},
                    socials: data.socials || {},
                    socialUrls: {
                        instagram: data.instagramUrl || "",
                        tiktok: data.tiktokUrl || "",
                        youtube: data.youtubeUrl || "",
                        linkedin: data.linkedinUrl || "",
                        facebook: data.facebookUrl || "",
                        twitter: data.twitterUrl || ""
                    },
                    subscriptionEnabled: data.subscriptionEnabled || false,
                    subscriptionPrice: data.subscriptionPrice || 0,
                    packageDetails: data.packageDetails || []
                };
                setProfileData(fresh);
                setProfileLink(`${window.location.origin}/${data.theUsername}`)


                // Date joined
                if (data.timestamp) {
                    const joinDate = data.timestamp.toDate ? data.timestamp.toDate() : new Date(data.timestamp);
                    const now = new Date();
                    const diffDays = Math.floor((now - joinDate) / (1000 * 60 * 60 * 24));
                    setDateJoined(`${diffDays} day${diffDays !== 1 ? "s" : ""} ago`);
                }

                // Profile views
                const viewsRef = dbRef(rdb, `profileViews/${uid}`);
                runTransaction(viewsRef, (current) => (current || 0) + 1)
                    .then(result => setProfileViews(result.snapshot.val()))
                    .catch(err => console.error("Profile view error:", err));

                setLoading(false);
            } catch (err) {
                console.error(err);
                setLoading(false);
                setUserData(null);
            }
        };

        fetchUser();
    }, [cleanUsername]);


    const { userName, theUsername, email, phoneNumber, mpesaNumber, profileImage, coverImage, adsNotAccepted, socials, socialUrls } = profileData;

    const data = {
        series: [
            {
                data: [20, 18, 35, 30, 32]
            }
        ],
        options: {
            chart: {
                type: "bar",
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 2,
                    columnWidth: "12"
                }
            },
            colors: ["#f7b6c8"],
            tooltip: { enabled: false },
            xaxis: {
                categories: [" ", " ", " ", " ", " "]
            },
            yaxis: {
                show: false

            },
            grid: { show: false },
            dataLabels: { enabled: false }
        }
    };

    useEffect(() => {
        if (!userData) return;

        // Page title
        document.title = `${userData.userName} (@${userData.theUsername}) | Zindua App`;

        // Description meta tag
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
            desc = document.createElement("meta");
            desc.setAttribute("name", "description");
            document.head.appendChild(desc);
        }
        desc.setAttribute("content", `Check out ${userData.userName}'s profile on Zindua App. View portfolio, socials, pricing, and subscription options.`);

        // Open Graph tags
        const ogTags = [
            { property: "og:title", content: `${userData.userName} (@${userData.theUsername}) | Zindua App` },
            { property: "og:description", content: `Check out ${userData.userName}'s profile on Zindua. View portfolio, socials, pricing, and subscription options.` },
            { property: "og:type", content: "profile" },
            { property: "og:url", content: `${window.location.origin}/${userData.theUsername}` },
            { property: "og:image", content: userData.profileImage || profDefault },
        ];

        ogTags.forEach(({ property, content }) => {
            let tag = document.querySelector(`meta[property='${property}']`);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("property", property);
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", content);
        });

        // JSON-LD structured data for a Person
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: userData.userName,
            url: `${window.location.origin}/${userData.theUsername}`,
            image: userData.profileImage || profDefault,
            sameAs: Object.values(userData.socialUrls || {}).filter(url => url),
            description: `View ${userData.userName}'s profile on Zindua App. Portfolio, social stats, and subscription options.`
        });
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [userData]);



    const handleCopyLink = () => {
        navigator.clipboard.writeText(profileLink)
            .then(() => {
                swal("Copied!", "You have copied this link", "success");
            })
            .catch(err => console.error('Copy failed', err));
    };

    function runAds() {
        if (isVerified === true && acceptingAds == true) {
            navigate(`/user/get-started/${userId}`);
        } else {
            swal("info", "Creator is not accepting ads at the moment", "info");
        }
    }

    function subscribeUser() {

        if (isSubscriptionActive == true && acceptingSubs == true) {
            navigate(`/user/subscribe/${userId}`)
        } else {
            swal("info", "Creator is not accepting subscriptions at the moment", "info");
        }

    }
    const formatNumber = (num) => {
        if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'm';
        if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
        return num.toString();
    };



    if (loading) {
        return <p>Loading...</p>;
    }

    if (!userData) {
        return <p>User not found</p>;
    }

    return (
        <div className='mainDashboard'>
            <div className="desktopOnly">
                <LeftbarUser />
            </div>
            <div className='mainContent'>
                <Topbar />
                <section className='topProfile'>

                    <div className='profileCover'>
                        <img src={coverImage} alt="" />
                    </div>

                    <div className='profilePhoto'>
                        <img src={profileImage} alt="" />
                    </div>

                    <div className='topProfileCont'>
                        <div>
                            <h2>{userName}</h2>
                            <p>
                                @{theUsername
                                    ? theUsername.length > 15
                                        ? theUsername.substring(0, 15) + '...'
                                        : theUsername
                                    : ''}
                            </p>

                        </div>

                        <button onClick={runAds}>Run an Ad</button>
                    </div>
                </section>

                {/* Tabs */}
                <div className="tabs" style={{ display: 'flex', marginBottom: '20px' }}>
                    <button
                        className={activeTab === 'socials' ? 'activeTab' : ''}
                        onClick={() => setActiveTab('socials')}
                        style={{ marginRight: '10px' }}
                    >
                        Portfolio
                    </button>
                    <button
                        className={activeTab === 'subscriptions' ? 'activeTab' : ''}
                        onClick={() => setActiveTab('subscriptions')}
                        style={{ marginRight: '10px' }}
                    >
                        Subscription
                    </button>
                    {/* <button
            className={activeTab === 'tip' ? 'activeTab' : ''}
            onClick={() => setActiveTab('tip')}
          >
            Tip Influencer
          </button> */}
                </div>

                {activeTab === 'socials' && (
                    <section className='profileStatMain'>
                        <div className='profileStatMain1'>
                            <div className='profileStatMain1Top'>
                                <div className='profileStatMain1Top1'>
                                    <FontAwesomeIcon icon={faFaceSmile} /> <span>Profile</span>
                                </div>
                                <div className='profileStatMainCont'>
                                    <p>Hi, im {userName}</p>
                                    <h6>Date Joined</h6>
                                    <p><FontAwesomeIcon icon={faClock} /> {dateJoined}</p>
                                    <h6>Profile Views</h6>
                                    <p><FontAwesomeIcon icon={faEye} /> {profileViews} Views</p>
                                    <button className="shareButton" onClick={handleCopyLink}>
                                        <FontAwesomeIcon icon={faShareAlt} />
                                        Share this Account
                                    </button>
                                </div>
                            </div>

                            <div className='profileStatMain1Bott'>
                                <div className='profileStatMain1Top11'>
                                    <FontAwesomeIcon icon={faWallet} /> <span>My Service Pricing</span>
                                </div>

                                <div className='pricingCardsContainer'>
                                    {Object.keys(servicePricing).length === 0 && (
                                        <p className='text-muted mt-2'>No pricing added yet</p>
                                    )}

                                    {['instagram', 'tiktok', 'youtube', 'twitter'].map(platform => {
                                        const data = servicePricing[platform];
                                        const isSelected = selectedPlatforms[platform];

                                        if (!isSelected || !data) return null;

                                        const direct = data.directBrandContent;
                                        const directHasPost = direct && direct.post;
                                        const directHasStory = direct && direct.story;
                                        const showDirect = direct && (directHasPost || directHasStory);

                                        const cgc = data.creatorGeneratedContent;
                                        const showCGC = cgc && cgc.description && cgc.price;

                                        if (!showDirect && !showCGC) return null;

                                        return (
                                            <div className={`pricingCard ${platform} mt-3`} key={platform}>
                                                <div className='pricingCardHeader'>
                                                    <FontAwesomeIcon
                                                        icon={
                                                            platform === 'instagram' ? faInstagram :
                                                                platform === 'tiktok' ? faTiktok :
                                                                    platform === 'youtube' ? faYoutube :
                                                                        faTwitter
                                                        }
                                                    />
                                                    <span className='ms-2 text-capitalize'>{platform}</span>
                                                </div>

                                                {showDirect && (
                                                    <div className='pricingSection'>
                                                        <div className='pricingTitle'>Direct Brand Content</div>

                                                        {directHasPost && (
                                                            <div>Post Upload: KES {Number(direct.post).toLocaleString()}</div>
                                                        )}

                                                        {directHasStory && (
                                                            <div>Story Upload: KES {Number(direct.story).toLocaleString()}</div>
                                                        )}
                                                    </div>
                                                )}

                                                {showCGC && (
                                                    <div className='pricingSection2'>
                                                        <div className='pricingTitle'>Creator Generated Content</div>
                                                        <div>{cgc.description}</div>
                                                        <div>KES {Number(cgc.price).toLocaleString()}</div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>


                        <div className='profileStatMain2'>

                            {/* instagram */}
                            {selectedPlatforms.instagram && (
                                <div className='profileSocialCard igCard'>
                                    <h6>Instagram</h6>

                                    <div className='profileSocialCardTop igCardTop'>
                                        <a href={'https://www.instagram.com/' + profileData.socialUrls.instagram || '#'} target='_blank' rel='noopener noreferrer'>
                                            <img src={icInstagram} alt="" />
                                        </a>

                                        <div>
                                            <p>Followers</p>
                                            <h4>{formatNumber(socialStats.instagram.followers || 0)}</h4>
                                        </div>
                                    </div>

                                    <div className='profileSocialCont'>
                                        <div>
                                            <p>Impression</p>
                                            <h4>{formatNumber(socialStats.instagram.impressions || 0)}</h4>

                                            <br />

                                            <p>Engagement</p>
                                            <h4>{formatNumber(socialStats.instagram.engagement || 0)}</h4>
                                        </div>

                                        <div className='profilesocialChart'>
                                            <Chart
                                                options={data.options}
                                                series={data.series}
                                                type="bar"
                                                height={200}
                                                width={150}
                                                className="socialChart"
                                            />
                                            <div className='bottomSocialStats'>
                                                <p>Last 90 Days</p>
                                                <a href={'https://www.instagram.com/' + profileData.socialUrls.instagram || '#'} target='_blank' rel='noopener noreferrer'>Open Instagram</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* twitter */}
                            {selectedPlatforms.twitter && (
                                <div className='profileSocialCard twitterCard'>
                                    <h6>Twitter</h6>

                                    <div className='profileSocialCardTop twitterTop'>
                                        <a href={'https://www.x.com/' + profileData.socialUrls.twitter || '#'} target='_blank' rel='noopener noreferrer'>
                                            <img src={icTwitter} alt="" />
                                        </a>

                                        <div>
                                            <p>Followers</p>
                                            <h4>{formatNumber(socialStats.twitter.followers || 0)}</h4>
                                        </div>
                                    </div>

                                    <div className='profileSocialCont'>
                                        <div>
                                            <p>Tweet impressions</p>
                                            <h4>{formatNumber(socialStats.twitter.tweetImpressions || 0)}</h4>

                                            <br />

                                            <p>Profile Views</p>
                                            <h4>{formatNumber(socialStats.twitter.profileViews || 0)}</h4>
                                        </div>

                                        <div className='profilesocialChart'>
                                            <Chart
                                                options={data.options}
                                                series={data.series}
                                                type="bar"
                                                height={200}
                                                width={150}
                                                className="socialChart"
                                            />
                                            <div className='bottomSocialStats'>
                                                <p>Last 90 Days</p>
                                                <a href={'https://www.x.com/' + profileData.socialUrls.twitter || '#'} target='_blank' rel='noopener noreferrer'>Open Twitter / X</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* tiktok */}
                            {selectedPlatforms.tiktok && (
                                <div className='profileSocialCard tiktokCard'>
                                    <h6>TikTok</h6>

                                    <div className='profileSocialCardTop tiktokCardTop'>
                                        <a href={'https://www.tiktok.com/@' + profileData.socialUrls.tiktok || '#'} target='_blank' rel='noopener noreferrer'>
                                            <img src={icTiktok} alt="" />
                                        </a>

                                        <div>
                                            <p>Followers</p>
                                            <h4>{formatNumber(socialStats.tiktok.followers || 0)}</h4>
                                        </div>
                                    </div>

                                    <div className='profileSocialCont'>
                                        <div>
                                            <p>Video impressions</p>
                                            <h4>{formatNumber(socialStats.tiktok.impressions || 0)}</h4>

                                            <br />

                                            <p>Total Likes</p>
                                            <h4>{formatNumber(socialStats.tiktok.likes || 0)}</h4>
                                        </div>

                                        <div className='profilesocialChart'>
                                            <Chart
                                                options={data.options}
                                                series={data.series}
                                                type="bar"
                                                height={200}
                                                width={150}
                                                className="socialChart"
                                            />
                                            <div className='bottomSocialStats'>
                                                <p>Last 60 Days</p>
                                                <a href={'https://www.tiktok.com/@' + profileData.socialUrls.tiktok || '#'} target='_blank' rel='noopener noreferrer'>Open TikTok</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* youtube */}
                            {selectedPlatforms.youtube && (
                                <div className='profileSocialCard fbCard'>
                                    <h6>Youtube</h6>

                                    <div className='profileSocialCardTop fbCardTop'>
                                        <a href={'https://youtube.com/@' + profileData.socialUrls.youtube || '#'} target='_blank' rel='noopener noreferrer'>
                                            <img src={icYoutube} alt="" />

                                        </a>

                                        <div>
                                            <p>Subscribers</p>
                                            <h4>{formatNumber(socialStats.youtube.subscribers || 0)}</h4>
                                        </div>
                                    </div>

                                    <div className='profileSocialCont'>
                                        <div>
                                            <p>Impression</p>
                                            <h4>{formatNumber(socialStats.youtube.impressions || 0)}</h4>

                                            <br />

                                            <p>Average View Duration</p>
                                            <h4>{formatNumber(socialStats.youtube.avgViewDuration || 0)}</h4>
                                        </div>

                                        <div className='profilesocialChart'>
                                            <Chart
                                                options={data.options}
                                                series={data.series}
                                                type="bar"
                                                height={200}
                                                width={150}
                                                className="socialChart"
                                            />
                                            <div className='bottomSocialStats'>
                                                <p>Last 90 Days</p>
                                                <a href={'https://youtube.com/@' + profileData.socialUrls.youtube || '#'} target='_blank' rel='noopener noreferrer'>Open Youtube</a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}

                        </div>

                    </section>
                )}

                {activeTab === 'subscriptions' && (
                    <section className='edtSubsription2'>
                        <div className='profileStatMain1 socialSubsLeft'>
                            <div className='profileStatMain1Top'>
                                <div className='profileStatMain1Top1'>
                                    <FontAwesomeIcon icon={faFaceSmile} /> <span>Profile</span>
                                </div>
                                <div className='profileStatMainCont'>
                                    <p>Hi, im {userName}</p>
                                    <h6>Date Joined</h6>
                                    <p><FontAwesomeIcon icon={faClock} /> {dateJoined}</p>
                                    <h6>Profile Views</h6>
                                    <p><FontAwesomeIcon icon={faEye} /> {profileViews} Views</p>
                                    <button className="shareButton" onClick={handleCopyLink}>
                                        <FontAwesomeIcon icon={faShareAlt} />
                                        Share this Account
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='profileStatMain2'>
                            {profileData.subscriptionEnabled && profileData.subscriptionPrice ? (
                                <div className='socialCard22'>
                                    <div className='socialCardTop'>
                                        <img src={subsImg} alt="" />
                                        <div>
                                            <p>Monthly Subscription</p>
                                            <h3>
                                                KES.{profileData.subscriptionPrice ? Number(profileData.subscriptionPrice).toLocaleString() : 0}
                                            </h3>

                                            <p>Per Month</p>
                                        </div>
                                    </div>

                                    <div className='socialCardCont22'>
                                        <h6>Package Detail</h6>
                                        <ul>
                                            {profileData.packageDetails?.length > 0
                                                ? profileData.packageDetails.map((item, i) => <li key={i}>{item}</li>)
                                                : <li>No details available</li>}
                                        </ul>

                                        <h6>About</h6>
                                        <p>This amount will be billed after every cycle of 30 daysrr</p>
                                        <button className='socialCardBtn' onClick={subscribeUser}>Subscribe to this Package</button>
                                    </div>


                                </div>
                            ) : (
                                <p>Creator has not enabled subscription</p>

                            )}



                        </div>
                    </section>
                )}

                {activeTab === 'tip' && (
                    <section className='edtSubsription'>
                        <h3>Tip Influencer</h3>
                        {/* Tip form, e.g., input for amount, button to pay */}
                    </section>
                )}


            </div>
            <div className="mobileOnly">
                <BottomNavUser />
            </div>


        </div>
    );
}

export default ViewUser;